<template>
<!--    <div class="row h-100">-->
<!--        <div class="col-xl-12 my-auto">-->
            <button class="btn btn-outline-info px-3 border-0 ml-2" id="menu-toggle"
                    @click="toggleSideNavHidden">
                <i class="fas fa-bars pt-1" style="font-size: 24px;"></i>
            </button>
<!--        </div>-->
<!--    </div>-->
</template>

<script>

    import { mapActions } from "vuex";

    export default {
        name: "MasterListSideNavToggle",

        methods: {
            ...mapActions([ 'toggleSideNavHidden' ])
        },
    }
</script>

<style scoped>

</style>
